import { createActionTypes } from 'apps/new-web/lib/redux-utils';
import request from 'apps/new-web/lib/request';
import { get } from 'lodash';

export const actionTypes = createActionTypes('POST_LOGIN_NAVIGATION', [
  'SHOW_MENU',
  'HIDE_MENU'
]);

function showMenu(name) {
  return { type: actionTypes.SHOW_MENU, name };
}

function hideMenu(name) {
  return { type: actionTypes.HIDE_MENU, name };
}

function updateUserField(path, value) {
  return (dispatch, getState) => {
    return request
      .post('/settings/updateUserField')
      .send({ path, value })
      .end()
      .catch((err) => {
        const errObj = get(err, 'response.body', err);
        throw Object.assign(errObj, { name: 'updateUserField' });
      });
  };
}


export const actionCreators = {
  showMenu,
  hideMenu,
  updateUserField,
};
